import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../../../components/layout";
import { BreadCrumb } from "primereact/breadcrumb";
import { useMutation, useQuery } from "@apollo/client";
import {
  ADD_BEHAVIORAL_CAMPAIGN,
  FETCH_ALL_CAMPAIGNS,
} from "../../../../../constants/graphql/settings-coin-queries";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  IconButton,
  Modal,
  Textarea,
} from "../../../../../components/core";
import { LOCKER_INFO } from "../../../../../constants/graphql/locker-queries";
import { Divider } from "primereact/divider";
import { Strings } from "../../../../../constants/strings";
import { REWARD_BEHAVIOR_TYPE } from "../../../settings-coins/dropdown-values";
import {
  formatDateToPHTParts,
  getBehaviorTypeLabel,
} from "../../../../../features/coin-campaigns/behavioral-campaign/dropdown";
import BehavioralMessageTemplates from "./components/message-templates";
import BehavioralCampaignMajorDetails from "./components/major-details";
import BehavioralCampaignDetails from "./components/campaign-details";
import { useSelector } from "react-redux";
import useSidebarStore from "../../../../../zustand/stores/sidebar-store";
import { formatDate, formatDateYYYYMMDD } from "../../../../../algorithms/date";

const EditBehavioralCampaign = () => {
  const { campaignBehaviorId } = useParams();
  const navigate = useNavigate();
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );
  const [behavioralData, setBehavioralData] = useState([]);
  const [openCancelModal, setOpenCancelModal] = React.useState(false);

  const [initialCampaignName, setInitialCampaignName] = useState("");
  const [changedLockerId, setChangedLockerId] = useState(false);
  const [convertedToDays, setConvertedToDays] = useState(null);
  const [updatedMessagesFormat, setUpdatedMessagesFormat] = useState({
    smsMessage1: "",
    smsMessage2: "",
    appMessage: "",
  });
  const [messagesFormat, setMessagesFormat] = useState(updatedMessagesFormat);
  const [changesMade, setChangesMade] = useState(false);

  const [behavioralVars, setBehavioralVars] = useState({
    campaignName: "",
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: "",
    lockerId: [],
    redemptionLimit: {
      campaign: null,
      person: null,
    },
    rewardedBehavior: null,
    smsMessage1: "",
    smsMessage2: "",
    appMessage: "",
    rewardParameter: [],
    // behavior reward is the equivalent days, weeks, months of rewarded behavior
    behaviorReward: {
      value: null,
      // set to 1 to set days by default
      behaviorRewardId: 1,
    },
    // rewardTypeStr: selectedReward.label,
    remarks: "",
  });
  const [prevBehavioralVars, setPrevBehavioralVars] = useState({
    smsMessage1: behavioralVars.smsMessage1,
    smsMessage2: behavioralVars.smsMessage2,
    // appMessage: behavioralVars.appMessage,
  });
  const [behaviorParameterList, setBehaviorParamterList] = useState([]);
  const [old, setOldBehaviorType] = useState("");
  const [operatorID, setOperatorID] = useState("");

  const [allLockersSelected, setAllLockersSelected] = useState(false);
  const [lockerName, setLockerName] = useState([]);
  const [behaviorTypeLabel, setBehaviorTypeLabel] = useState("");
  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
    actions: "",
  });

  useEffect(() => {
    const fetchOperatorID = () => {
      let opIDLocal = localStorage.getItem("user");
      let opIDLocal2 = JSON.parse(opIDLocal);
      if (opIDLocal2) {
        setOperatorID(opIDLocal2.operator_id);
      }
    };

    fetchOperatorID();
  }, []);
  // zustand
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);
  // gql
  const campaignData = useQuery(FETCH_ALL_CAMPAIGNS, {
    variables: {
      filters: {
        campaignId: campaignBehaviorId,
        operatorId: operatorID,
      },
    },
  });
  const { data: allLockerNames } = useQuery(LOCKER_INFO, {
    variables: { operatorId: operatorID },
  });

  const [updateBehavioralCampaign] = useMutation(ADD_BEHAVIORAL_CAMPAIGN);

  // temporary dropdown list
  const behaviorTypeList = REWARD_BEHAVIOR_TYPE.filter((x) => x.value !== 2);

  const durationOptions = [
    { label: "days", value: 1 },
    { label: "weeks", value: 2 },
    { label: "months", value: 3 },
  ];

  const defaultHeaders = [
    {
      header: behaviorTypeLabel || "Reward Parameter",
      field: "parameterValue",
      // key: "params_name",
      sortable: "true",
    },
    {
      header: "MBOX Coins to be Earned",
      field: "coins_value",
      // key: "coins_value",
      sortable: "true",
    },
  ];

  // breadcrumbs
  const home = {
    icon: "pi pi-home",
    url: `${process.env.REACT_APP_BASE_ENVIRONMENT}mbox-behavioral-campaigns`,
  };
  const breadcrumbItems = [{ label: "Edit Behavioral Campaign", path: "#" }];

  const handleChange = (event, rowData) => {
    const { name, value } = event.target;
    const keys = name.split(".");
    setChangesMade(true);

    if (keys.length === 2) {
      // Nested property update
      const updatedValue = value === 0 ? " " : value;
      setBehavioralVars((prevState) => ({
        ...prevState,
        [keys[0]]: {
          ...prevState[keys[0]],
          [keys[1]]: updatedValue?.toString(),
        },
      }));
    } else if (name === "parameterValue" || name === "coins_value") {
      const index = rowData.index;
      setBehaviorParamterList((prevState) => {
        const updatedList = [...prevState];
        updatedList[index] = {
          ...updatedList[index],
          [keys[0]]: value,
        };
        return updatedList;
      });
    } else {
      if (name === "rewardedBehavior") {
        setBehavioralVars((prevState) => {
          const newState = { ...prevState, [name]: value };
          if (name === "rewardedBehavior") {
            setOldBehaviorType(prevState.rewardedBehavior || "");
          }
          return newState;
        });
      } else {
        if (name === "lockerId") {
          const currentLockers = behavioralVars.lockerId || [];
          const updatedLockerId = value; // Assuming `value` is the updated list of locker IDs

          const isBulkRemoval =
            currentLockers.length > 0 &&
            updatedLockerId.length < currentLockers.length &&
            updatedLockerId.length === 0;
          console.log({ currentLockers, updatedLockerId, isBulkRemoval });

          if (isBulkRemoval) {
            // Show confirmation dialog
            setValidation({
              icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
              title: "Remove All Lockers?",
              message:
                "Do you want to remove all the lockers for this campaign?",
              open: true,
              actions: (
                <div className="grid grid-cols-2 gap-2">
                  {/* No Button */}
                  <Button
                    onClick={() => {
                      setValidation((prev) => ({ ...prev, open: false }));
                      // Revert to previous state (retain the lockers)
                      setBehavioralVars((prevState) => ({
                        ...prevState,
                        lockerId: currentLockers, // Restore original lockers
                      }));
                      setChangedLockerId(false);
                    }}
                    value={"No"}
                    className={"p-2"}
                  />
                  {/* Yes Button */}
                  <Button
                    onClick={() => {
                      setValidation((prev) => ({ ...prev, open: false }));
                      // Allow removing all lockers
                      setBehavioralVars((prevState) => ({
                        ...prevState,
                        lockerId: [], // Clear all lockers
                      }));
                      setChangedLockerId(true);
                      setAllLockersSelected(false);
                    }}
                    value={"Yes"}
                    className={"p-2"}
                  />
                </div>
              ),
            });
          } else {
            // Normal behavior for other updates
            const hasAllLockers = updatedLockerId.some(
              (locker) => locker.value === 0 || locker.value === "0"
            );
            console.log({ hasAllLockers });
            setAllLockersSelected(hasAllLockers);

            if (hasAllLockers) {
              // Append all lockers when "All Lockers" is selected
              const allLockers = lockerName.filter(
                (locker) => locker.value !== 0 && locker.value !== "0"
              );

              setBehavioralVars((prevState) => ({
                ...prevState,
                lockerId: [...allLockers], // Append all lockers
              }));
            } else {
              // Normal update
              setBehavioralVars((prevState) => ({
                ...prevState,
                [name]: value,
              }));
            }

            setChangedLockerId(true);
          }
        } else {
          // Handle other cases
          setChangedLockerId(false);
          setBehavioralVars((prevState) => ({
            ...prevState,
            [name]: value,
          }));
        }
      }
    }
  };

  console.log({ behavioralVars });
  // const getBehaviorTypeLabel = (value) => {
  // 	const behavior = behaviorTypeList.find(
  // 		(item) => item.value === parseInt(value)
  // 	);
  // 	return behavior ? behavior.name : "";
  // };
  console.log({ behavioralData });
  useEffect(() => {
    if (behavioralData.length > 0) {
      const lockerIds = behavioralData[0].lockerId;

      // Check if lockerId contains 0
      const hasZeroValue = lockerIds.includes(0);
      console.log({ lockerIds, hasZeroValue });

      if (hasZeroValue) {
        setAllLockersSelected(true);
      } else if (lockerIds.length === 0) {
        setAllLockersSelected(false);
      }
    }
  }, [behavioralData]);

  useEffect(() => {
    if (pendingNavigation !== null) {
      if (changesMade) {
        setOpenCancelModal(true);
        // setValidation({
        // 	icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        // 	title: `${Strings.popup_confirm_cancel_title}?`,
        // 	message: Strings.popup_confirm_cancel_massage,
        // 	open: true,
        // 	actions: (
        // 		<div className="flex justify-between gap-3">
        // 			<Button
        // 				onClick={() => {
        // 					setValidation({ open: false });
        // 					// window.location.reload();
        // 					setPendingNavigation(null);
        // 					setActiveSubItem(activeSubItem);
        // 				}}
        // 				value={"No"}
        // 				className={"p-2 w-full"}
        // 			/>
        // 			<Button
        // 				onClick={() => {
        // 					navigate(pendingNavigation);
        // 					setPendingNavigation(null);
        // 				}}
        // 				value={"Yes"}
        // 				className={"p-2 w-full"}
        // 			/>
        // 		</div>
        // 	),
        // });
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, changesMade]);

  const findLockerName = (lockerIdArray, lockerName) => {
    const lockerDetails = lockerIdArray?.map((lockerId) => {
      const locker = lockerName?.find(
        (locker) => parseInt(locker.value) === parseInt(lockerId)
      );
      return locker ? { value: locker.value, label: locker.label } : null;
    });

    return lockerDetails;
  };

  const handleAddRow = () => {
    const newRow = {
      index: behaviorParameterList.length,
      parameterValue: "",
      params_name: behavioralVars.rewardedBehavior, // Initial value for params_name
      coins_value: null, // Initial value for coins_value
    };

    setBehaviorParamterList((prevList) => [...prevList, newRow]);

    setBehavioralVars((prevVars) => ({
      ...prevVars,
      rewardParameter: [...prevVars.rewardParameter, newRow],
    }));
  };

  const handleDeleteRow = (rowData) => {
    // Filter out the row to be deleted
    let updatedRows = behaviorParameterList.filter(
      (row) => row.index !== rowData.index
    );

    // Update the indexes of the remaining rows
    updatedRows = updatedRows.map((row, index) => ({
      ...row,
      index: index, // Reassign index
    }));

    setBehavioralVars({
      ...behavioralVars,
      rewardParameter: updatedRows,
    });

    setBehaviorParamterList(updatedRows);
    // setDeleteSuccess(true);
  };

  const convertBehaviorRewardIdToDays = (behaviorRewardId) => {
    // console.log({ behavioralVars });
    const behaviorRewardMapping = {
      1: { value: 1, unit: "days" }, // Example for 'days'
      2: { value: 2, unit: "weeks" }, // Example for 'weeks'
      3: { value: 3, unit: "months" }, // Example for 'months'
      // Add more cases as needed
    };

    const reward = behaviorRewardMapping[behaviorRewardId];
    if (!reward) {
      return 0;
    }

    switch (reward.unit) {
      case "days":
        return behavioralVars.behaviorReward.value;
      case "weeks":
        return behavioralVars.behaviorReward.value * 7;
      case "months":
        return behavioralVars.behaviorReward.value * 30;
      default:
        return 0;
    }
  };

  const validateFields = () => {
    let startDateTime = new Date(
      `${behavioralVars.startDate}T${behavioralVars.startTime}`
    );
    let endDateTime = new Date(
      `${behavioralVars.endDate}T${behavioralVars.endTime}`
    );

    let durationInMilliseconds = endDateTime - startDateTime;

    // Convert milliseconds to days
    let durationInDays = durationInMilliseconds / (1000 * 60 * 60 * 24);

    // console.log({ convertedToDays, behavioralVars });
    // console.log({ startDateTime, endDateTime });

    if (
      behavioralVars.campaignName === "" ||
      behavioralVars.startDate === "" ||
      behavioralVars.endDate === "" ||
      behavioralVars.startTime === "" ||
      behavioralVars.endTime === "" ||
      behavioralVars.lockerId.length === 0 ||
      behavioralVars.redemptionLimit.campaign === null ||
      behavioralVars.redemptionLimit.person === null ||
      behavioralVars.rewardedBehavior === "" ||
      behaviorParameterList.length === 0 ||
      updatedMessagesFormat.smsMessage1 === "" ||
      updatedMessagesFormat.smsMessage2 === "" ||
      updatedMessagesFormat.appMessage === ""
    ) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Incomplete Fields",
        message: "Please fill out all the fields to proceed",
        open: true,
        actions: (
          <div className="grid grid-cols-1">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else if (
      new Date(behavioralVars.startDate) > new Date(behavioralVars.endDate)
    ) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Campaign Date",
        message: "End date cannot be later than start date.",
        open: true,
        actions: (
          <div className="grid grid-cols-1">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else if (startDateTime > endDateTime) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Campaign Time",
        message: "End time cannot be greater than start time on the same day.",
        open: true,
        actions: (
          <div className="grid grid-cols-1">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else if (startDateTime.getTime() === endDateTime.getTime()) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Campaign Time",
        message: "End time cannot be equal to start time on the same day.",
        open: true,
        actions: (
          <div className="grid grid-cols-1">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else if (
      behavioralVars.rewardedBehavior === "2" &&
      convertedToDays > durationInDays
    ) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Time Frame",
        message: "Time frame is greater than campaign date",
        open: true,
        actions: (
          <div className="grid grid-cols-1">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else {
      // 	// setShowSaveDialogOpen(true);
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
        title: Strings.popup_confirm_save_title,
        message: Strings.popup_confirm_save_massage,
        open: true,
        actions: (
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"No"}
              className={"p-2"}
            />
            <Button
              onClick={() => {
                // console.log("why");
                handleSaveChanges();
              }}
              value={"Yes"}
              className={"p-2"}
              // disabled={
              // 	accessPermission.lockerUserType === 1 ||
              // 	accessPermission.lockerUserType === "1"
              // }
            />
          </div>
        ),
      });
    }
  };

  const determineCampaignStatus = (item, totalRedemptions) => {
    // console.log({ item, totalRedemptions });

    const campaignEndDate = new Date(item);

    const today = new Date();
    // console.log({ campaignEndDate, today });
    console.log({ campaignEndDate, today });
    if (today > campaignEndDate) {
      return 2; // Assuming value 2 is for "Expired"
    } else {
      return 1; // Assuming value 1 is for "Active"
    }
  };

  const handleSaveChanges = () => {
    let allLockersExist = true;
    const lockerIds = behavioralVars.lockerId
      .map((locker) => locker.value)
      .filter((locker) => locker.value !== 0 && locker.value !== "0");

    allLockerNames.lockerInfo.forEach((locker) => {
      if (!lockerIds.includes(parseInt(locker.lockerId))) {
        allLockersExist = false;
      }
    });

    let transformedBehaviorParameterList = behaviorParameterList?.map(
      (item) => ({
        index: item.index,
        value: item.coins_value,
        seconds: item.parameterValue * 3600,
      })
    );
    let behaviorParameterString = JSON.stringify(
      transformedBehaviorParameterList
    );

    const stringMessages = {
      sms_message1: updatedMessagesFormat.smsMessage1,
      sms_message2: updatedMessagesFormat.smsMessage2,
      app_message: updatedMessagesFormat.appMessage,
    };

    let finalStr = JSON.stringify(stringMessages);

    // console.log({ allLockersExist, lockerIds });
    updateBehavioralCampaign({
      variables: {
        id: campaignBehaviorId,
        title: behavioralVars.campaignName,
        // status: 1,
        status: determineCampaignStatus(behavioralVars.endDate),
        operatorId: operatorID,
        lockerIds: allLockersSelected ? [0] : lockerIds,
        behaviorType: behavioralVars.rewardedBehavior,
        behaviorParams: behaviorParameterString,
        rewardParams: finalStr,
        rewardType: 1,
        redemptionLimit:
          behavioralVars.redemptionLimit.campaign === " "
            ? 0
            : behavioralVars.redemptionLimit.campaign,
        userLimit:
          behavioralVars.redemptionLimit.person === " "
            ? 0
            : behavioralVars.redemptionLimit.person,
        startDate: `${formatDateYYYYMMDD(behavioralVars.startDate)}T${
          behavioralVars.startTime
        }+08:00`,
        endDate: `${formatDateYYYYMMDD(behavioralVars.endDate)}T${
          behavioralVars.endTime
        }+08:00`,
        remarks: behavioralVars.remarks,
      },
    })
      .then((response) => {
        if (response) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: "Success",
            message: `Behavioral Campaign successfully edited.`,
            open: true,
            actions: (
              <div className="w-full">
                <Button
                  onClick={() => {
                    setValidation({ open: false });
                    window.location.reload();
                  }}
                  value={"OK"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        }
      })
      .catch((e) => {
        console.error({ e });
      });
  };
  const areAllLockerIdsMatching = (behavioralData, lockerNames) => {
    if (!behavioralData || behavioralData.length === 0) return false;

    // Check if every lockerId in behavioralData exists in lockerNames
    return behavioralData.every((behavior) =>
      behavior.lockerId.every((lockerId) =>
        lockerNames.some((locker) => locker.value === lockerId)
      )
    );
  };

  // useeffect to fetch the data
  useEffect(() => {
    if (campaignData?.data) {
      const behaviorData = campaignData.data.allCampaignBehaviors.map((e) => ({
        ...e,
        campaignName: e.campaignTitle,
      }));

      setInitialCampaignName(behaviorData[0]?.campaignName || "");
      setBehavioralData(behaviorData);
    }
  }, [campaignData]);

  useEffect(() => {
    if (allLockerNames?.lockerInfo) {
      // const lockerOptions = [
      // 	{ value: "0", label: "All Lockers" },
      // 	...allLockerNames.lockerInfo.map((element) => ({
      // 		value: element.lockerId,
      // 		label: element.lockerName,
      // 	})),
      // ];

      let tempData = [
        // {
        // 	value: "0",
        // 	label: "All Lockers",
        // },
      ];

      allLockerNames.lockerInfo.forEach((element) => {
        tempData.push({
          value: element.lockerId,
          label: element.lockerName,
        });
      });

      if (!allLockersSelected) {
        tempData.unshift({
          value: "0",
          label: "All Lockers",
        });
      }
      setLockerName(tempData);
    }
  }, [allLockerNames, allLockersSelected]);

  // useEffect(() => {
  // 	if (behavioralData.length > 0 && !changedLockerId) {
  // 		const data = behavioralData[0];
  // 		const hasAllLockers = data?.lockerId?.includes(0);
  // 		// Example: Automatically select all lockers if lockerId is 0
  // 		if (hasAllLockers) {
  // 			setAllLockersSelected(true);
  // 		} else {
  // 			setAllLockersSelected(false);
  // 		}
  // 	}
  // }, [behavioralData, changedLockerId]);

  // useEffect(() => {
  // 	if (changedLockerId && allLockersSelected) {
  // 		const selectedLockers = lockerName.filter(
  // 			(locker) => locker.value !== 0 || locker.value !== "0"
  // 		);

  // 		setBehavioralVars({
  // 			...behavioralVars,
  // 			lockerId: selectedLockers,
  // 		});
  // 	}
  // }, [allLockersSelected, changedLockerId, lockerName]);
  console.log({ allLockersSelected, changedLockerId });
  // Consolidated behavioral data, lockerName, and allLockersSelected handling
  useEffect(() => {
    if (
      behavioralData.length > 0 &&
      lockerName.length > 0 &&
      !changedLockerId
    ) {
      console.log("you are here again");
      const data = behavioralData[0];
      console.log({ data });
      const selectedLockers = lockerName.filter(
        (locker) => locker.value !== 0 || locker.value !== "0"
      );

      const parsedReward = JSON.parse(data.campaignBehaviorParameters);
      const transformedBehaviorParameterList = parsedReward.map((item) => ({
        index: item.index,
        coins_value: item.value,
        parameterValue: item.seconds / 3600,
      }));

      const parsedMessages = JSON.parse(data.campaignRewardParameters);
      const transformedSMS = {
        smsMessage1: parsedMessages.sms_message1,
        smsMessage2: parsedMessages.sms_message2,
        appMessage: parsedMessages.app_message,
      };

      const { startDate, startTime } = formatDateToPHTParts(data.startDate);

      const { endDate, endTime } = formatDateToPHTParts(data.endDate);

      console.log({ startDate, endDate });
      setBehavioralVars({
        campaignName: data.campaignTitle,
        startDate,
        startTime,
        endDate,
        endTime,
        lockerId: allLockersSelected
          ? selectedLockers
          : findLockerName(data.lockerId, lockerName),
        redemptionLimit: {
          campaign: data.campaignRedemptionLimit,
          person: data.userRedemptionLimit,
        },
        rewardedBehavior: data.campaignBehaviorTypeNo,
        rewardParameter: transformedBehaviorParameterList,
        behaviorReward: {
          value: data.campaignRewardParameters,
          behaviorRewardId: data.campaignRewardTypeNo,
        },
        remarks: data.remarks,
        ...transformedSMS,
      });

      setBehaviorParamterList(transformedBehaviorParameterList);
      setPrevBehavioralVars(transformedSMS);
      setUpdatedMessagesFormat(transformedSMS);
    }
  }, [behavioralData, lockerName, allLockersSelected, changedLockerId]);

  useEffect(() => {
    if (behavioralVars.rewardedBehavior) {
      setBehaviorTypeLabel(
        getBehaviorTypeLabel(behavioralVars.rewardedBehavior)
      );
    }
  }, [behavioralVars.rewardedBehavior]);

  // Reward behavior ID conversion to days
  useEffect(() => {
    if (behavioralVars.behaviorReward.behaviorRewardId !== "1") {
      const days = convertBehaviorRewardIdToDays(
        behavioralVars.behaviorReward.behaviorRewardId
      );
      setConvertedToDays(days);
    }
  }, [behavioralVars.behaviorReward.behaviorRewardId]);

  const addButtonTemplate = () => (
    <div
      style={{ textAlign: "center" }}
      className={`flex justify-center ${
        accessPermission.behavioralCampaign === 1 ||
        accessPermission.behavioralCampaign === "1"
          ? "hidden"
          : ""
      }`}
    >
      <Button
        value={"Add Reward Parameter"}
        className={`p-2 mx-auto px-5 ${
          !behaviorTypeLabel ? "cursor-not-allowed" : ""
        }`}
        onClick={() => {
          handleAddRow();
        }}
        disabled={!behaviorTypeLabel}
      />
    </div>
  );
  const [editingIndex, setEditingIndex] = useState(null);

  const actionTemplate = (rowData, index) => {
    // console.log({ rowData, options });
    setEditingIndex(index);

    return (
      <IconButton
        type="button"
        icon="pi pi-trash"
        className="bg-red-500 text-white text-center items-center"
        onClick={() => {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: "Delete Reward Parameter",
            message: "Do you want to remove this reward parameter?",
            open: true,
            actions: (
              <div className="grid grid-cols-2 gap-2">
                <Button
                  onClick={() => {
                    setValidation((prev) => ({
                      ...prev,
                      open: false,
                    }));

                    // if (!deleteClicked) {
                    // 	setBehavioralVars((prevState) => ({
                    // 		...prevState,
                    // 		behaviorType: old,
                    // 	}));
                    // }
                  }}
                  value={"No"}
                  className={"p-2"}
                />
                <Button
                  onClick={() =>
                    // onDeleteLockerAssignment(
                    // 	validation.header.event,
                    // 	validation.header.partnerBranchAssignmentId
                    // )
                    {
                      handleDeleteRow(rowData);
                      setValidation((prev) => ({
                        ...prev,
                        open: false,
                      }));

                      // setSelectedRowData(rowData);
                      // setDeleteClicked(true);
                    }
                  }
                  value={"Yes"}
                  className={"p-2"}
                />
              </div>
            ),
          });
        }}
      />
    );
  };

  return (
    <ContentContainer>
      <div className="w-full">
        <BreadCrumb
          home={home}
          model={breadcrumbItems}
          className="p-3 outline outline-1 outline-primary-primaryYellow"
        ></BreadCrumb>

        <div className="h-full w-full px-2">
          <div className="text-xl font-bold pt-3">
            {initialCampaignName ? initialCampaignName : "Edit Locker Name"}
          </div>

          {/* try separating the page */}
          <BehavioralCampaignMajorDetails
            behavioralVars={behavioralVars}
            handleChange={handleChange}
            lockerName={lockerName}
          />
        </div>

        {/* divider */}
        <div className="w-full px-9">
          <Divider className=" border border-gray-200 px-11"></Divider>
        </div>
        {/* end of divider */}

        <BehavioralCampaignDetails
          behavioralVars={behavioralVars}
          handleChange={handleChange}
          behaviorTypeList={behaviorTypeList}
          durationOptions={durationOptions}
          behaviorParameterList={behaviorParameterList}
          addButtonTemplate={addButtonTemplate}
          behaviorTypeLabel={behaviorTypeLabel}
          actionTemplate={actionTemplate}
        />

        <div className="w-full px-9">
          <Divider className=" border border-gray-200 px-11"></Divider>
        </div>

        <BehavioralMessageTemplates
          updatedMessagesFormat={updatedMessagesFormat}
          setUpdatedMessagesFormat={setUpdatedMessagesFormat}
          behavioralVars={behavioralVars}
          messagesFormat={messagesFormat}
          setMessagesFormat={setMessagesFormat}
        />

        <div className="w-full px-9">
          <Divider className=" border border-gray-200 px-11"></Divider>
        </div>

        <div>
          <div className="px-[1.25rem]">
            {/* <div className="font-bold text-black text-lg  ">Others:</div> */}

            <div className="px-2 grid grid-cols-12">
              <div className="col-span-6">
                <div className="grid grid-cols-12">
                  <label className="col-span-4 ">Remarks:</label>
                  <div className="col-span-8">
                    <Textarea
                      disabled={`${
                        accessPermission.behavioralCampaign === 1 ||
                        accessPermission.behavioralCampaign === "1"
                      }`}
                      className="w-full"
                      rows={5}
                      onChange={handleChange}
                      name={"remarks"}
                      value={behavioralVars.remarks}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-2 py-3">
          <div className="col-span-5"></div>
          <Button
            className={`p-2 font-normal mx-auto border bg-white border-primary-primaryYellow px-3
							${
                accessPermission.behavioralCampaign === 1 ||
                accessPermission.behavioralCampaign === "1"
                  ? "hidden"
                  : ""
              }`}
            value={"Cancel"}
            onClick={() => setOpenCancelModal(true)}
          />
          <Button
            className={`p-2 mx-auto px-5 	${
              accessPermission.behavioralCampaign === 1 ||
              accessPermission.behavioralCampaign === "1"
                ? "hidden"
                : ""
            }`}
            value={"Save"}
            onClick={() => validateFields()}
          />
        </div>
      </div>

      <Modal
        icon={`${process.env.PUBLIC_URL}/assets/images/error.png`}
        title="Cancel Changes"
        message="Are you sure you want to cancel all changes?"
        open={openCancelModal}
        actions={
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => {
                setOpenCancelModal(false);
                setActiveSubItem(activeSubItem);
                setPendingNavigation(null);
              }}
              value={"No"}
              className={"p-2"}
            />
            <Button
              onClick={() => {
                if (pendingNavigation) {
                  navigate(pendingNavigation);
                  setPendingNavigation(null);
                  setChangesMade(false);
                } else {
                  navigate(`/mbox-behavioral-campaigns/`);
                }
              }}
              value={"Yes"}
              className={"p-2"}
            />
          </div>
        }
      />

      {/* Modal for removing confirmation */}
      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </ContentContainer>
  );
};

export default EditBehavioralCampaign;
